'use client';
import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import axios from '@/lib/axios';
import { toast } from 'react-toastify';
import { API_SURPRIZE_STORE } from '@/constant/apiRout';
import { pushToDataLayer } from '@/features/gtm/gtmUtils';

interface formData {
  phone: String;
}
function SurpriseGiftForm({ btn_name }: { btn_name: string }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<formData>();
  const onSubmit: SubmitHandler<formData> = async (data) => {
    try {
      const res = await axios.post(API_SURPRIZE_STORE, data);
      if (res?.data?.result) {
        toast.success(res?.data?.message || 'Successful');
        pushToDataLayer('generate_lead', { currency: 'BDT' });
      } else {
        toast.error(res?.data?.message || 'Failed');
      }
    } catch (error: any) {
      toast.error(error?.message || 'Failed');
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="sale-card__form">
      <input
        type="text"
        inputMode="numeric"
        className="form-control"
        placeholder="Phone Number"
        onInput={(e) => {
          e.currentTarget.value = e.currentTarget.value.replace(/\D/g, '');
        }}
        {...register('phone', {
          required: 'Phone number is required',
          minLength: {
            value: 11,
            message: 'Phone number must be exactly 11 digits',
          },
          maxLength: {
            value: 11,
            message: 'Phone number must be exactly 11 digits',
          },
          pattern: {
            value: /^\d{11}$/,
            message: 'Phone number must contain only numbers',
          },
        })}
      />

      {errors.phone && <p className="text-danger">{errors.phone.message}</p>}

      <button className="trk-btn trk-btn--primary  d-block mt-2">
        {btn_name || 'Submit'}
      </button>
    </form>
  );
}

export default SurpriseGiftForm;
